import { ref, computed } from '@vue/composition-api';
import { omitBy, isNil } from 'lodash';
export const useResourcesTableQuery = (config = {}) => {
    const { defaultPerPage = 25, filterParams = {}, filterTransforms = {}, fieldMap = {}, staticParams = {}, sortKey = 'sortBy', perPageKey = 'limit', } = config;
    const page = ref(1);
    const perPage = ref(defaultPerPage);
    const sort = ref(undefined);
    const initializeFilters = () => {
        const localFilters = {};
        Object.keys(filterParams).forEach((filterKey) => {
            localFilters[filterKey] = { filter: null };
        });
        return localFilters;
    };
    const filters = ref(initializeFilters());
    const query = computed(() => {
        const baseQuery = {
            page: page.value,
            [perPageKey]: perPage.value,
        };
        if (sort.value) {
            baseQuery[sortKey] = sort.value;
        }
        Object.entries(staticParams).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                baseQuery[key] = value;
            }
        });
        Object.entries(filterParams).forEach(([filterKey]) => {
            let filterValue = filters.value[filterKey]?.filter;
            if (filterValue !== null &&
                filterValue !== undefined &&
                filterValue !== '') {
                const transform = filterTransforms[filterKey];
                if (transform) {
                    filterValue = transform(filterValue);
                }
                if (filterValue) {
                    baseQuery[filterKey] = filterValue;
                }
            }
        });
        const { page: _, [perPageKey]: __, ...cleanableQuery } = baseQuery;
        const cleanQuery = omitBy(cleanableQuery, (value) => isNil(value) || value === '');
        return {
            ...cleanQuery,
            page: page.value,
            [perPageKey]: perPage.value,
        };
    });
    const handleSort = (field, direction) => {
        const sortField = fieldMap[field] || field;
        const prefix = direction === 'asc' ? '' : '-';
        sort.value = `${prefix}${sortField}`;
        page.value = 1;
    };
    const resetSort = () => {
        sort.value = undefined;
        page.value = 1;
    };
    const handleFilterChange = (filterModel) => {
        Object.keys(filters.value).forEach((filterKey) => {
            const mappedFieldName = Object.keys(fieldMap).find((key) => fieldMap[key] === filterKey);
            const agFilter = (filterModel[filterKey] ||
                (mappedFieldName && filterModel[mappedFieldName]));
            if (agFilter && agFilter.filter !== undefined) {
                filters.value[filterKey] = { filter: agFilter.filter };
            }
            else if (agFilter && agFilter.values && agFilter.values.length > 0) {
                filters.value[filterKey] = { filter: agFilter.values[0] };
            }
            else {
                filters.value[filterKey] = { filter: null };
            }
        });
        page.value = 1;
    };
    return {
        page,
        perPage,
        sort,
        filters,
        query,
        handleSort,
        resetSort,
        handleFilterChange,
    };
};
